import type { WikiBlock } from "../types";

/** Judgment Selling forbidden — compact (SSOT: forbidden). */
export const sellForbiddenBlocks: readonly WikiBlock[] = [
  {
    type: "callout",
    tone: "warning",
    text: "아래는 코드·실험에서 다시 시도하지 말 항목입니다. 자세한 근거는 호스트 Judgment Selling 정본을 봅니다.",
  },
  { type: "h2", text: "하지 말 것" },
  {
    type: "table",
    headers: ["금지", "이유 (한 줄)"],
    rows: [
      [
        "힐 소유 고정 + 사거리 밖 추격(Claim B)",
        "웨이브 검증에서 거절됨 · 경로 없음",
      ],
      [
        "유대로 직감 급피 문 / 평시 자리 강제",
        "Soft가 평타보다 훨씬 작다는 계약·인형극",
      ],
      [
        "직감만으로 엄폐 자리 선호 단독 배선",
        "통찰 생존-자리와 이중 클레임",
      ],
      [
        "Soft 이속 버스트를 직감으로 판매",
        "Soft 생존 바닥 ≠ 재능",
      ],
      [
        "부관이 개인 생존 추구를 강제",
        "시드 제안만 · 직감/통찰 소유",
      ],
      [
        "극단 = 전투 계수·쿨감·HP 치트",
        "판단 차이만 보여야 함",
      ],
    ],
  },
  { type: "h2", text: "극단이 보이면" },
  {
    type: "ul",
    items: [
      "직감 아주 높음 → 피하느라 딜·힐 포기",
      "직감 아주 낮음 → 장판에서 맞고 싸움",
      "통찰 아주 높음 → 망설이다 타이밍 놓침",
      "유대 아주 높음 → 안내에 과하게 끌림",
    ],
  },
];
